import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { Observable } from 'rxjs'

import { eps } from './url.service'
import { LoginHistory } from '../store/login-history/login-history.state'

export interface LoginHistoryResponse {
  loginHistories: LoginHistory[]
  totalCount: number
  totalRowCount: number
  successfulLoginCount: number
  failedLoginCount: number
  loggedOutLoginCount: number
}

@Injectable({
  providedIn: 'root'
})
export class LoginHistoryService {
  private apiUrl = eps.userLoginHistory.listApi

  constructor(private http: HttpClient) {}

  getLoginHistories(
    params?: string | null,
    page?: number,
    limit?: number
  ): Observable<LoginHistoryResponse> {
    const queryParams: string[] = []

    if (params) {
      queryParams.push(params)
    }

    if (page !== undefined) {
      queryParams.push(`page=${page}`)
    }

    if (limit !== undefined) {
      queryParams.push(`limit=${limit}`)
    }

    const url = queryParams.length ? `${this.apiUrl}?${queryParams.join('&')}` : this.apiUrl

    return this.http.get<LoginHistoryResponse>(url)
  }

  getLoginHistoryById(id: string): Observable<LoginHistory> {
    return this.http.get<LoginHistory>(`${this.apiUrl}/${id}`)
  }
}
